import { useQuery } from "@tanstack/react-query";

import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import {
  ICampaignFieldConfigResponse,
  IFieldConfig,
  IFieldConfigResponse,
} from "@shared/lib/types/briefInfluencerV2";
import {
  BRIEF_CAMPAIGN_DATA_FIELDS_QUERY_KEY,
  BRIEF_DATA_FIELDS_QUERY_KEY,
} from "../../constants";
import { BriefConfigService } from "../../services/briefConfigService";

export function useGetBriefCampaignDataFields(briefId: string) {
  const { data, isError, isLoading, error } = useQuery<
    BackednResponse<ICampaignFieldConfigResponse>
  >({
    queryKey: [...BRIEF_CAMPAIGN_DATA_FIELDS_QUERY_KEY, briefId],
    queryFn: () => BriefConfigService.getBriefCampaignDataFields(briefId),
    enabled: !!briefId,
  });

  const errorMessage = isError && error?.message;
  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    dataFields: data?.data,
    isFetching: isLoading,
  };
}
